import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import styled from 'styled-components';

import usePlaceholderImageFixed from '@hooks/Utils/UsePlaceholderImageFixed';

import pattern_gray_tiles from '@img/pattern7.png';

const StyledLazyLoadImage = styled(LazyLoadImage)`
    height: auto;
    width: auto;
    max-width: ${(props) =>
        props.$maxwidth ? `${props.$maxwidth}px !important` : (props) => (props.$maxheight ? 'none' : '200px')};
    max-height: ${(props) =>
        props.$maxheight ? `${props.$maxheight}px !important` : (props) => (props.$maxwidth ? 'none' : '200px')};
    &.model-cover-middle {
        max-width: 80px;
    }
    &.model-cover-small {
        max-width: 40px;
    }
    &.model-cover-xsmall {
        max-width: 30px;
    }
    &.model-cover-cropped {
        width: ${(props) => (props.$maxwidth ? props.$maxwidth : '6rem')};
        object-fit: cover;
        object-position: center;
        aspect-ratio: 4/5;
    }
`;
const StyledImage = styled.img`
    height: auto;
    width: auto;
    max-width: ${(props) =>
        props.$maxwidth ? `${props.$maxwidth}px !important` : (props) => (props.$maxheight ? 'none' : '200px')};
    max-height: ${(props) =>
        props.$maxheight ? `${props.$maxheight}px !important` : (props) => (props.$maxwidth ? 'none' : '200px')};
    &.model-cover-middle {
        max-width: 80px;
    }
    &.model-cover-small {
        max-width: 40px;
    }
    &.model-cover-xsmall {
        max-width: 30px;
    }
    &.is-placeholder {
        opacity: 0.6;
    }
`;

const ModelCover = ({ model, classN, maxWidth, maxHeight, ...rest }) => {
    if (!model) {
        return (
            <StyledImage
                className={`${classN} is-placeholder`}
                $maxwidth={maxWidth}
                $maxheight={maxHeight}
                src={pattern_gray_tiles}
                alt="Model Cover Not Set"
                {...rest}
            />
        );
    }

    let modelCoverGuid = null;
    // check if model is an object or a string
    if (typeof model === 'object') {
        if (model.CG) {
            modelCoverGuid = model.CG;
        } else if (model.CoverGuid) {
            modelCoverGuid = model.CoverGuid;
        }
        const modelSubType = model ? (model.ST ? model.ST : 4) : null;
        const [urlbg, isPlaceholder] = usePlaceholderImageFixed(modelCoverGuid, modelSubType);
        if (!isPlaceholder) {
            return (
                <StyledLazyLoadImage
                    className={classN}
                    $maxwidth={maxWidth}
                    $maxheight={maxHeight}
                    alt="Model Cover"
                    src={urlbg}
                    {...rest}
                />
            );
        } else {
            return (
                <StyledImage
                    className={`${classN} is-placeholder`}
                    $maxwidth={maxWidth}
                    $maxheight={maxHeight}
                    src={urlbg}
                    alt="Model Cover Not Set"
                    {...rest}
                />
            );
        }
    } else if (typeof model === 'string') {
        return (
            <StyledLazyLoadImage
                className={classN}
                $maxwidth={maxWidth}
                $maxheight={maxHeight}
                alt="Model Cover"
                src={model}
                {...rest}
            />
        );
    }
};

export { ModelCover };
